import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { VideoFirstHeroDataQuery, VideoFirstHeroDataQueryVariables } from './api.graphql';
import { VideoFirstHeroData as VideoFirstHeroDataQueryDocument } from './api.graphql';
import { getTikTokPlayerUrl } from './source';

export type VideoFirstHeroData = Readonly<{ enabled: false }> | Readonly<{ enabled: true; sourceUrl: string }>;

const DISABLED_VIDEO_FIRST_HERO = { enabled: false } as const;

export async function getVideoFirstHeroData(
	utilityContext: UtilityContext,
	slugOrId: string,
): Promise<VideoFirstHeroData> {
	try {
		const {
			data: { petition },
		} = await utilityContext.gql.fetch<VideoFirstHeroDataQuery, VideoFirstHeroDataQueryVariables>({
			query: VideoFirstHeroDataQueryDocument,
			variables: { slugOrId },
			path: '/video-first-hero',
			rejectOnError: true,
		});
		const sourceUrl = petition?.socialStarterPetitionAngles?.metadata?.sourceUrl ?? undefined;

		return sourceUrl && getTikTokPlayerUrl(sourceUrl) ? { enabled: true, sourceUrl } : DISABLED_VIDEO_FIRST_HERO;
	} catch (error) {
		void utilityContext.errorReporter.report(error as Error, { severity: 'warning' });
		return DISABLED_VIDEO_FIRST_HERO;
	}
}
